import { joinList } from "./list";
import { dateFnsLocale } from "./locale";
const TRAILING_PERIOD = /\.$/;
const shortCache = new Map();
/** 2026-09-13 is a Sunday; `+ day` lands on that weekday, at UTC noon. */
function sampleDay(day) {
    return new Date(Date.UTC(2026, 8, 13 + day, 12));
}
/**
 * "seg", "sáb" / "Mon", "Sat". Intl, not date-fns: date-fns' ptBR has no
 * three-letter form with the accent (`short` is "sab", `abbreviated` is
 * "segunda"). Intl's pt-BR short form carries a trailing period, dropped here.
 */
export function weekdayShort(day, locale) {
    let format = shortCache.get(locale);
    if (!format) {
        format = new Intl.DateTimeFormat(locale, {
            timeZone: "UTC",
            weekday: "short",
        });
        shortCache.set(locale, format);
    }
    return format.format(sampleDay(day)).replace(TRAILING_PERIOD, "");
}
/** "segunda-feira" / "Monday". */
export function weekdayLong(day, locale) {
    return dateFnsLocale(locale).localize.day(day, { width: "wide" });
}
/** Monday-first rank: Monday 0 … Sunday 6. */
const isoRank = (day) => (day + 6) % 7;
function normalise(weekdays) {
    return [...new Set(weekdays)]
        .filter((d) => Number.isInteger(d) && d >= 0 && d <= 6)
        .sort((a, b) => isoRank(a) - isoRank(b));
}
/**
 * How many training days a week: the distinct fixed weekdays plus the
 * flexible ones. The sentence ("3 por semana") is a Paraglide message.
 */
export function daysPerWeek(weekdays, flexibleDays = 0) {
    return normalise(weekdays).length + Math.max(0, flexibleDays);
}
/**
 * The fixed weekdays, Monday first, joined: "seg, qua e sex" /
 * "Mon, Wed, and Fri". Empty for no days — the screen's message says what
 * "no fixed day" means. Replaces A2's `routineDaysLabel`/`sameDaysLabel`
 * only for the list; their sentences are Paraglide.
 */
export function routineDaysLabel(weekdays, locale) {
    return joinList(normalise(weekdays).map((d) => weekdayShort(d, locale)), locale);
}
//# sourceMappingURL=weekday.js.map